"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AppHooksListenerService", {
    enumerable: true,
    get: function() {
        return AppHooksListenerService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _utils = require("~/utils");
const _models = require("~/models");
const _telemetryservice = require("~/services/telemetry.service");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let AppHooksListenerService = class AppHooksListenerService {
    async hookHandler({ event, data }) {
        const { req, clientId } = data;
        switch(event){
            case _nocodbsdk.AppEvents.USER_SIGNIN:
                break;
            case _nocodbsdk.AppEvents.USER_SIGNOUT:
                break;
            case _nocodbsdk.AppEvents.USER_SIGNUP:
                {
                    var _param_user;
                    const param = data;
                    // assign user to req (as this is self-event)
                    param.req.user = param.user;
                    this.telemetryService.sendEvent({
                        evt_type: 'a:signup',
                        req,
                        clientId,
                        email: (_param_user = param.user) == null ? void 0 : _param_user.email
                    });
                }
                break;
            case _nocodbsdk.AppEvents.USER_INVITE:
                {
                    var _param_user1;
                    const param = data;
                    this.telemetryService.sendEvent({
                        evt_type: 'a:signup',
                        req,
                        clientId,
                        email: (_param_user1 = param.user) == null ? void 0 : _param_user1.email
                    });
                }
                break;
            case _nocodbsdk.AppEvents.USER_UPDATE:
                break;
            case _nocodbsdk.AppEvents.USER_PASSWORD_CHANGE:
                break;
            case _nocodbsdk.AppEvents.USER_PASSWORD_FORGOT:
                break;
            case _nocodbsdk.AppEvents.USER_DELETE:
                break;
            case _nocodbsdk.AppEvents.USER_PASSWORD_RESET:
                break;
            case _nocodbsdk.AppEvents.USER_EMAIL_VERIFICATION:
                break;
            case _nocodbsdk.AppEvents.PROJECT_INVITE:
                break;
            case _nocodbsdk.AppEvents.PROJECT_USER_UPDATE:
                break;
            case _nocodbsdk.AppEvents.PROJECT_USER_RESEND_INVITE:
                break;
            case _nocodbsdk.AppEvents.TABLE_CREATE:
                break;
            case _nocodbsdk.AppEvents.TABLE_DELETE:
                break;
            case _nocodbsdk.AppEvents.TABLE_UPDATE:
                break;
            case _nocodbsdk.AppEvents.VIEW_CREATE:
                break;
            case _nocodbsdk.AppEvents.VIEW_DELETE:
                break;
            case _nocodbsdk.AppEvents.COLUMN_CREATE:
                break;
            case _nocodbsdk.AppEvents.COLUMN_UPDATE:
                break;
            case _nocodbsdk.AppEvents.DATA_CREATE:
                break;
            case _nocodbsdk.AppEvents.DATA_DELETE:
                break;
            case _nocodbsdk.AppEvents.DATA_UPDATE:
                break;
            case _nocodbsdk.AppEvents.COLUMN_DELETE:
                break;
            case _nocodbsdk.AppEvents.META_DIFF_SYNC:
                {
                    const param = data;
                    if (param.source) {
                        this.telemetryService.sendEvent({
                            evt_type: 'a:baseMetaDiff:synced',
                            req,
                            clientId
                        });
                    } else {
                        this.telemetryService.sendEvent({
                            evt_type: 'a:metaDiff:synced',
                            req,
                            clientId
                        });
                    }
                }
                break;
            case _nocodbsdk.AppEvents.ORG_USER_INVITE:
                break;
            case _nocodbsdk.AppEvents.ORG_USER_RESEND_INVITE:
                break;
            case _nocodbsdk.AppEvents.VIEW_COLUMN_UPDATE:
                break;
            case _nocodbsdk.AppEvents.IMAGE_UPLOAD:
                break;
            case _nocodbsdk.AppEvents.FORM_COLUMN_UPDATE:
                break;
            case _nocodbsdk.AppEvents.PROJECT_CREATE:
                break;
            case _nocodbsdk.AppEvents.PROJECT_UPDATE:
                break;
            case _nocodbsdk.AppEvents.PROJECT_CLONE:
                break;
            case _nocodbsdk.AppEvents.WELCOME:
                break;
            case _nocodbsdk.AppEvents.WORKSPACE_CREATE:
                break;
            case _nocodbsdk.AppEvents.WORKSPACE_DELETE:
                break;
            case _nocodbsdk.AppEvents.WORKSPACE_UPDATE:
                break;
            case _nocodbsdk.AppEvents.PROJECT_DELETE:
                break;
            case _nocodbsdk.AppEvents.GRID_CREATE:
                break;
            case _nocodbsdk.AppEvents.GRID_COLUMN_UPDATE:
                break;
            case _nocodbsdk.AppEvents.GRID_DELETE:
                break;
            case _nocodbsdk.AppEvents.GRID_DUPLICATE:
                break;
            case _nocodbsdk.AppEvents.FORM_CREATE:
                break;
            case _nocodbsdk.AppEvents.FORM_UPDATE:
            case _nocodbsdk.AppEvents.GRID_UPDATE:
            case _nocodbsdk.AppEvents.CALENDAR_UPDATE:
            case _nocodbsdk.AppEvents.GALLERY_UPDATE:
            case _nocodbsdk.AppEvents.KANBAN_UPDATE:
            case _nocodbsdk.AppEvents.LIST_UPDATE:
            case _nocodbsdk.AppEvents.VIEW_UPDATE:
                break;
            case _nocodbsdk.AppEvents.FORM_DELETE:
                break;
            case _nocodbsdk.AppEvents.KANBAN_CREATE:
                break;
            case _nocodbsdk.AppEvents.KANBAN_DELETE:
                break;
            case _nocodbsdk.AppEvents.GALLERY_CREATE:
                break;
            case _nocodbsdk.AppEvents.GALLERY_DELETE:
                break;
            case _nocodbsdk.AppEvents.CALENDAR_CREATE:
                break;
            case _nocodbsdk.AppEvents.CALENDAR_DELETE:
                break;
            case _nocodbsdk.AppEvents.LIST_CREATE:
                break;
            case _nocodbsdk.AppEvents.LIST_DELETE:
                break;
            case _nocodbsdk.AppEvents.FILTER_CREATE:
                break;
            case _nocodbsdk.AppEvents.FILTER_UPDATE:
                break;
            case _nocodbsdk.AppEvents.FILTER_DELETE:
                break;
            case _nocodbsdk.AppEvents.WEBHOOK_CREATE:
                break;
            case _nocodbsdk.AppEvents.WEBHOOK_UPDATE:
                break;
            case _nocodbsdk.AppEvents.WEBHOOK_DELETE:
                break;
            case _nocodbsdk.AppEvents.SORT_CREATE:
                break;
            case _nocodbsdk.AppEvents.SORT_UPDATE:
                break;
            case _nocodbsdk.AppEvents.SORT_DELETE:
                break;
            case _nocodbsdk.AppEvents.API_TOKEN_CREATE:
            case _nocodbsdk.AppEvents.ORG_API_TOKEN_CREATE:
                break;
            case _nocodbsdk.AppEvents.PLUGIN_TEST:
                break;
            case _nocodbsdk.AppEvents.PLUGIN_INSTALL:
                break;
            case _nocodbsdk.AppEvents.PLUGIN_UNINSTALL:
                break;
            case _nocodbsdk.AppEvents.SYNC_SOURCE_CREATE:
                break;
            case _nocodbsdk.AppEvents.SYNC_SOURCE_UPDATE:
                break;
            case _nocodbsdk.AppEvents.SYNC_SOURCE_DELETE:
                break;
            case _nocodbsdk.AppEvents.RELATION_DELETE:
                break;
            case _nocodbsdk.AppEvents.RELATION_CREATE:
                break;
            case _nocodbsdk.AppEvents.API_TOKEN_DELETE:
            case _nocodbsdk.AppEvents.ORG_API_TOKEN_DELETE:
                break;
            case _nocodbsdk.AppEvents.SHARED_VIEW_CREATE:
                break;
            case _nocodbsdk.AppEvents.SHARED_VIEW_UPDATE:
                break;
            case _nocodbsdk.AppEvents.SHARED_VIEW_DELETE:
                break;
            case _nocodbsdk.AppEvents.SHARED_BASE_GENERATE_LINK:
                break;
            case _nocodbsdk.AppEvents.SHARED_BASE_DELETE_LINK:
                break;
            case _nocodbsdk.AppEvents.ATTACHMENT_UPLOAD:
                {
                    this.telemetryService.sendEvent({
                        evt_type: 'image:uploaded',
                        type: data == null ? void 0 : data.type
                    });
                }
                break;
            case _nocodbsdk.AppEvents.APIS_CREATED:
                break;
            case _nocodbsdk.AppEvents.EXTENSION_CREATE:
                break;
            case _nocodbsdk.AppEvents.EXTENSION_UPDATE:
                break;
            case _nocodbsdk.AppEvents.EXTENSION_DELETE:
                break;
            case _nocodbsdk.AppEvents.COMMENT_CREATE:
                break;
            case _nocodbsdk.AppEvents.COMMENT_DELETE:
                break;
            case _nocodbsdk.AppEvents.COMMENT_UPDATE:
                break;
            case _nocodbsdk.AppEvents.INTEGRATION_DELETE:
                break;
            case _nocodbsdk.AppEvents.INTEGRATION_CREATE:
                break;
            case _nocodbsdk.AppEvents.INTEGRATION_UPDATE:
                break;
            case _nocodbsdk.AppEvents.ROW_USER_MENTION:
                break;
            case _nocodbsdk.AppEvents.SOURCE_CREATE:
                break;
            case _nocodbsdk.AppEvents.SOURCE_UPDATE:
                break;
            case _nocodbsdk.AppEvents.SOURCE_DELETE:
                break;
            case _nocodbsdk.AppEvents.BASE_DUPLICATE_START:
            case _nocodbsdk.AppEvents.BASE_DUPLICATE_FAIL:
                break;
            case _nocodbsdk.AppEvents.TABLE_DUPLICATE_START:
            case _nocodbsdk.AppEvents.TABLE_DUPLICATE_FAIL:
                break;
            case _nocodbsdk.AppEvents.COLUMN_DUPLICATE_START:
            case _nocodbsdk.AppEvents.COLUMN_DUPLICATE_FAIL:
                break;
            case _nocodbsdk.AppEvents.VIEW_DUPLICATE_START:
            case _nocodbsdk.AppEvents.VIEW_DUPLICATE_FAIL:
                break;
            case _nocodbsdk.AppEvents.UI_ACL:
                break;
            case _nocodbsdk.AppEvents.RECORD_TEMPLATE_CREATE:
            case _nocodbsdk.AppEvents.RECORD_TEMPLATE_UPDATE:
            case _nocodbsdk.AppEvents.RECORD_TEMPLATE_DELETE:
            case _nocodbsdk.AppEvents.RECORD_TEMPLATE_USE:
                break;
        }
    }
    onModuleDestroy() {
        this.unsubscribe == null ? void 0 : this.unsubscribe.call(this);
    }
    onModuleInit() {
        this.unsubscribe = this.appHooksService.onAll(this.hookHandler.bind(this));
    }
    async auditInsert(param) {
        try {
            await _models.Audit.insert(param);
            _utils.T.event(_extends({}, param, {
                created_at: Date.now()
            }));
        } catch (e) {
            this.logger.error(e);
        }
    }
    constructor(appHooksService, telemetryService){
        this.appHooksService = appHooksService;
        this.telemetryService = telemetryService;
        this.logger = new _common.Logger(AppHooksListenerService.name);
    }
};
AppHooksListenerService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _telemetryservice.TelemetryService === "undefined" ? Object : _telemetryservice.TelemetryService
    ])
], AppHooksListenerService);
